import { render, staticRenderFns } from "./GeneralViewTab.vue?vue&type=template&id=d668cd94&scoped=true&"
import script from "./GeneralViewTab.vue?vue&type=script&lang=js&"
export * from "./GeneralViewTab.vue?vue&type=script&lang=js&"
import style0 from "./GeneralViewTab.vue?vue&type=style&index=0&id=d668cd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d668cd94",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QBtnToggle,QTooltip,QIcon,QLinearProgress,QSlideTransition,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QBtnToggle,QTooltip,QIcon,QLinearProgress,QSlideTransition})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
